$('.toggle_password').click(function () {
    let passwordControl = $("#" + $(this).data("password-control"));

    if (passwordControl.attr("type") === "password") {
        // Currently password, toggle to text
        passwordControl.attr("type", "text");
        $(this).addClass("fa-eye-slash");
        $(this).removeClass("fa-eye");
    }
    else {
        // Currently text, toggle to password
        passwordControl.attr("type", "password");
        $(this).addClass("fa-eye");
        $(this).removeClass("fa-eye-slash");
    }
});
